import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapImage } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { prepareImage } from '../_filters';
let PresentationModuleUi = class PresentationModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.image = null;
    }
    async fetchRelated() {
        if (this.module.content.image === null) {
            this.onReady();
            return;
        }
        try {
            const imageFile = await this.relatedService.resolve(this.module.content.image, {});
            if (!imageFile) {
                this.onReady();
                return;
            }
            const maxWidth = this.isMobile ? 768 : 1220;
            this.image = prepareImage(imageFile, this.imageRatio, maxWidth, this.module.isLazyLoaded);
            if (!this.image || !this.image.src) {
                this.onError(new Error('Invalid image object'));
                return;
            }
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    get hasTextCol() {
        return this.textWidthPercent > 0;
    }
    get hasImageCol() {
        return this.imageWidthPercent > 0 && !!this.module.content.image;
    }
    get processedHeading() {
        if (!this.module.content.heading) {
            return '';
        }
        return this.module.content.heading.replace(/\*([^*]+)\*/g, '<span>$1</span>');
    }
    get textWidthPercent() {
        return this.clamp(this.module.content.textWidthPercent, 0, 100);
    }
    get imageWidthPercent() {
        return 100 - this.textWidthPercent;
    }
    get cssVariables() {
        return `--text-width: ${this.textWidthPercent}; --image-width: ${this.imageWidthPercent}; --has-image: ${this.hasImageCol ? 1 : 0};`;
    }
    get textOrderClass() {
        return this.module.content.side === 'left' ? '--order-1' : '--order-2';
    }
    get imageOrderClass() {
        return this.module.content.side === 'left' ? '--order-2' : '--order-1';
    }
    clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
};
PresentationModuleUi = __decorate([
    Component({
        name: 'PresentationModuleUi',
        components: { BootstrapImage },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="presentation-module" :class="[themeClass, sizeClass, debugClass]" :id="module.content.anchor" :style="cssVariables">
      <div class="container">
        <div class="presentation-module__content">
          <div v-if="hasTextCol" class="presentation-module__text" :class="textOrderClass">
            <h2 v-if="module.content.heading" v-html="processedHeading" />
            <div v-if="module.content.text" v-html="module.content.text" />
            <div v-if="module.content.linkLabel && module.content.linkHref" class="presentation-module__link">
              <a :href="module.content.linkHref">{{ module.content.linkLabel }}</a>
            </div>
          </div>
          <div v-if="hasImageCol" class="presentation-module__image" :class="imageOrderClass">
            <BootstrapImage v-if="image && image.src" v-bind="image" :isLazy="false" />
          </div>
        </div>
      </div>
    </section>
  `
    })
], PresentationModuleUi);
export { PresentationModuleUi };
